import { LOGIN_LOADING, LOGIN_LOGOUT, LOGIN_ERROR } from './actions';
import { QUIZ_START } from '../quiz/actions';

const initialState = {
  isLoading: false,
  schoolCode: '',
  classNumber: '',
  studentId: '',
  error: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_LOADING:
      return Object.assign({}, state, { isLoading: true, error: null });
    case LOGIN_LOGOUT:
      return Object.assign({}, initialState);
    case LOGIN_ERROR:
      return Object.assign({}, state, action.payload, { isLoading: false });
    case QUIZ_START:
      return Object.assign({}, state, {
        isLoading: false,
        schoolCode: action.payload.schoolCode,
        classNumber: action.payload.classNumber,
        studentId: action.payload.studentId,
        error: null,
      });
    default:
      return state;
  }
}
